const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'https://trailcode-backend.onrender.com';

export default BACKEND_URL;